import { render, staticRenderFns } from "./CursosPainelView.vue?vue&type=template&id=d52f646e&scoped=true&"
import script from "./CursosPainelView.vue?vue&type=script&lang=js&"
export * from "./CursosPainelView.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=d52f646e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52f646e",
  null
  
)

export default component.exports